const ENERGY_MODE_BY_RAW_VALUE = { elec: 'ELECTRICITY', gas: 'NATURAL_GAS' }

// A select left untouched must not silently resolve to a valid backend value (e.g. 'OTHER'),
// or the backend's required/in-list validation can never catch a missing selection.
const mapEnergyMode = rawValue => {
  if (!rawValue) {
    return ''
  }
  return ENERGY_MODE_BY_RAW_VALUE[rawValue] ?? 'OTHER'
}

const OCCUPANCY_FREQUENCY_BY_RESIDENCE_PRESENCE = { 0: 'ALL_DAY', 1: 'NIGHT_WE' }

const mapOccupancyFrequency = addressData => {
  if (addressData?.residenceType !== 'main') {
    return 'NIGHT_WE'
  }
  return OCCUPANCY_FREQUENCY_BY_RESIDENCE_PRESENCE[addressData?.energyLandscape?.residencePresence] ?? ''
}

export const buildCarPayload = ({ addressData, contactId }) => {
  const heatingMode = mapEnergyMode(addressData?.heatingEnergy)
  const cookingMode = mapEnergyMode(addressData?.cookingEnergy)
  const hotWaterMode = mapEnergyMode(addressData?.hotwaterEnergy)
  const occupancyFrequency = mapOccupancyFrequency(addressData)

  return {
    version: 'v2',
    contactId,
    addressId: addressData?.id ?? 0,
    housingType: addressData?.housingType === 'apartment' ? 'FLAT' : 'HOUSE',
    surface: addressData?.surface || 0,
    mainHome: addressData?.residenceType === 'main' ? 'MAIN' : 'SECONDARY',
    occupantsNumber: addressData?.energyLandscape?.numberOfOccupants || 0,
    heatingMode,
    cookingMode,
    hotWaterMode,
    rawHeating: addressData?.heatingEnergy || '',
    rawCooking: addressData?.cookingEnergy || '',
    rawHotWater: addressData?.hotwaterEnergy || '',
    occupancyFrequency,
    recentInsulationWork: addressData?.energyLandscape?.recentInsulationWork || '',
    dishwasher: addressData?.energyLandscape?.dishwasher === true ? 'true' : '',
    dryer: addressData?.energyLandscape?.dryer === true ? 'true' : '',
    separateFreezer: addressData?.energyLandscape?.freezer === true ? 'true' : '',
    electricCar: addressData?.energyLandscape?.electricCar === true ? 'true' : '',
    electricCarDistance: addressData?.energyLandscape?.electricCarDistance || 0,
    airConditionersOneRoom: addressData?.energyLandscape?.airConditionersOneRoom === true ? 'true' : '',
    airConditionersMultipleRooms: addressData?.energyLandscape?.airConditionersMultipleRooms === true ? 'true' : '',
    heatPump: addressData?.energyLandscape?.heatPump === true ? 'true' : '',
    numberDays: addressData?.energyLandscape?.numberDays || 0,
  }
}
